import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CustomText, { getFontSize } from "../CustomText";
import Grid from "@material-ui/core/Grid";
import Color from "../../../utils/Color";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Images from "../../../assets";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "#e4e4ea",
    padding: "20px",
    position: "fixed",
    left: 0,
    bottom: 0,
    right: 0,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  containerXSMD: {
    backgroundColor: "#e4e4ea",
    //padding: "20px",
    paddingTop: 5,
    paddingBottom: 5,
    position: "fixed",
    left: 0,
    bottom: 0,
    right: 0,
    margin: 0,
    //marginTop:50,
    //display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    
    //height:"55px"
  },
  textStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    paddingRight: 30,
    cursor: "pointer",
    marginTop: 3,
  },
  otherTextStyle: {
    ...getFontSize("small"),
    color: Color.primaryTextColor,
    opacity: 0.8,
    paddingRight: 20,
    cursor: "pointer",
    marginTop: 3,
  },
  imageStyle: {
    width: 25,
    height: 25,
    cursor: "pointer",
    marginBottom: -5,
  },
}));

const Footer = ({ open, EnrolGiroFooter, props }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.only("xs"));
  const matchesMD = useMediaQuery(theme.breakpoints.only("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.only("sm"));
  const onClickEtiqaInsurance = () => {
    window.open("https://www.etiqa.com.sg/");
  };

  const onClickOnlineSecurity = () => {
    window.open(
      "https://www.etiqa.com.sg/useful-information/online-security-tips/"
    );
  };

  const onClickPrivacyStatement = () => {
    window.open(
      "https://www.etiqa.com.sg/useful-information/privacy-statement/"
    );
  };

  const onClickFairDealing = () => {
    window.open("https://www.etiqa.com.sg/useful-information/fair-dealing/");
  };

  const onClickDataProtection = () => {
    window.open("https://www.etiqa.com.sg/useful-information/data-protection/");
  };

  const onClickFB = () => {
    window.open("https://www.facebook.com/Etiqasg");
  };

  const onClickLinked = () => {
    window.open("https://www.linkedin.com/company/etiqa-insurance-pte-ltd-");
  };

  const onClickYoutube = () => {
    window.open("https://www.youtube.com/channel/UCUagFnn5V1FVj4ISQW7GN0g");
  };

  const usePathname = () => {
    const location = useLocation();
    return console.log(location.pathname);
  };

  var d = new Date();
  var n = d.getFullYear();
  const location = useLocation();
  return (
    <div>
      {matchesXS ? (
        <div
          className={classes.containerXSMD}
          style={{
            backgroundColor:
            location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview"
                ? localStorage.getItem("MyToken")
                  ? "#000000"
                  : "#8a8a8a"
                : false,
              display: location.pathname === "/PolicyInfo" ? "none" : ""
          }}
        >
          <Grid
            item
            container
            xs={12}
            sm={12}
            md={10}
            justify={matchesXS || matchesSM ? "center" : "flex-start"}
            style={{
              paddingLeft: open ? 280 : 0,
              marginRight: matchesXS ? 0 : 0,
            }}
          >
            <Grid item>
              <CustomText
                className={classes.textStyle}
                onClick={onClickEtiqaInsurance}
                style={{
                  color:
                  location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview"
                      ? "#fff"
                      : false,
                  paddingTop:
                  location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview"
                      ? 12
                      : false,
                  paddingBottom:
                  location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview"
                      ? 12
                      : false,
                }}
              >
                © {n} Etiqa Insurance Pte. Ltd.
              </CustomText>
            </Grid>

            {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
              false
            ) : (
              <Grid item>
                <CustomText
                  className={classes.otherTextStyle}
                  onClick={onClickOnlineSecurity}
                >
                  Online Security Tips
                </CustomText>
              </Grid>
            )}

            {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
              false
            ) : (
              <Grid item>
                <CustomText
                  className={classes.otherTextStyle}
                  onClick={onClickPrivacyStatement}
                >
                  Privacy Statement
                </CustomText>
              </Grid>
            )}

            {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
              false
            ) : (
              <Grid item>
                <CustomText
                  className={classes.otherTextStyle}
                  onClick={onClickFairDealing}
                >
                  Fair Dealing
                </CustomText>
              </Grid>
            )}

            {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
              false
            ) : (
              <Grid item>
                <CustomText
                  className={classes.otherTextStyle}
                  onClick={onClickDataProtection}
                >
                  Data Protection
                </CustomText>
              </Grid>
            )}
          </Grid>

          {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
            false
          ) : (
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={2}
              spacing={2}
              justify={matchesXS || matchesSM ? "center" : "flex-end"}
              style={{
                paddingRight: matchesMD ? 30 : 0,
                paddingLeft: matchesSM && open ? 200 : 0,
              }}
            >
              <Grid item>
                <img
                  src={Images.facebookLogo}
                  className={classes.imageStyle}
                  onClick={onClickFB}
                />
              </Grid>
              <Grid item>
                <img
                  src={Images.linkedInLogo}
                  className={classes.imageStyle}
                  onClick={onClickLinked}
                />
              </Grid>
              <Grid item>
                <img
                  src={Images.youtubeLogo}
                  className={classes.imageStyle}
                  onClick={onClickYoutube}
                />
              </Grid>
            </Grid>
          )}
        </div>
      ) : (
        <div
          className={classes.container}
          style={{
            backgroundColor:
            location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview"
                ? localStorage.getItem("MyToken")
                  ? "#000000"
                  : "#8a8a8a"
                : false,
          }}
        >
          <Grid container spacing={matchesXS ? 2 : 0}>
            <Grid
              item
              container
              xs={12}
              sm={9}
              md={10}
              style={{
                paddingLeft: matchesMD ? 0 : 30,
                marginRight: matchesXS ? 30 : 0,
              }}
            >
              <Grid item>
                <CustomText
                  className={classes.textStyle}
                  onClick={onClickEtiqaInsurance}
                  style={{
                    color:
                    location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview"
                        ? "#fff"
                        : false,
                  }}
                >
                  © {n} Etiqa Insurance Pte. Ltd.
                </CustomText>
              </Grid>

              {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
                false
              ) : (
                <Grid item>
                  <CustomText
                    className={classes.otherTextStyle}
                    onClick={onClickOnlineSecurity}
                  >
                    Online Security Tips
                  </CustomText>
                </Grid>
              )}

              {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
                false
              ) : (
                <Grid item>
                  <CustomText
                    className={classes.otherTextStyle}
                    onClick={onClickPrivacyStatement}
                  >
                    Privacy Statement
                  </CustomText>
                </Grid>
              )}

              {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
                false
              ) : (
                <Grid item>
                  <CustomText
                    className={classes.otherTextStyle}
                    onClick={onClickFairDealing}
                  >
                    Fair Dealing
                  </CustomText>
                </Grid>
              )}

              {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
                false
              ) : (
                <Grid item>
                  <CustomText
                    className={classes.otherTextStyle}
                    onClick={onClickDataProtection}
                  >
                    Data Protection
                  </CustomText>
                </Grid>
              )}
            </Grid>

            {location.pathname === "/EnrolGiro" ||
                location.pathname === "/enrolgiro" ||
                location.pathname === "/EnrolGiroInfo" ||
                location.pathname === "/GiroStatus" ||
                location.pathname === "/GiroProcess" ||
                location.pathname === "/GiroReview" ? (
              false
            ) : (
              <Grid
                item
                container
                xs={12}
                sm={3}
                md={2}
                spacing={2}
                justify={matchesXS ? "center" : "flex-end"}
                style={{ paddingRight: matchesMD ? 30 : 60 }}
              >
                <Grid item>
                  <img
                    src={Images.facebookLogo}
                    className={classes.imageStyle}
                    onClick={onClickFB}
                  />
                </Grid>
                <Grid item>
                  <img
                    src={Images.linkedInLogo}
                    className={classes.imageStyle}
                    onClick={onClickLinked}
                  />
                </Grid>
                <Grid item>
                  <img
                    src={Images.youtubeLogo}
                    className={classes.imageStyle}
                    onClick={onClickYoutube}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </div>
      )}
    </div>
  );
};

export default Footer;
